import {
  Table,
  TableHead,
  TableRow,
  Paper,
  Card,
  CardContent,
  Typography,
  Grid,
  Collapse,
  TableBody,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Button,
  Divider,
  Alert,
} from "@mui/material";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { styled } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import "moment/locale/he";
import Container from "@mui/material/Container";
import { RolesContext } from "../context/User";
import React from "react";
import LoadingBox from "./Loading";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { decode as base64_decode } from "base-64";
import LoadingButton from "@mui/lab/LoadingButton";
import { FlashAuto } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";

export default function ShippingList({ clicked, data }) {
  const [invoice, setInvoice] = useState([]);
  const [invoicedetails, setInvoiceDetails] = useState([]);
  const [message, setMessage] = useState(false);
  const [alert, setAlert] = useState(false);
  const [fromdate, setFromdate] = useState();
  const [todate, setTodate] = useState();
  const [loadingDeitals, setLoadingDeitals] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [typeFile, settypeFile] = useState(null);
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const navigate = useNavigate();
  const [expandedFiles, setExpandedFiles] = useState({});
  const [expanded, setExpanded] = useState({
    invoice: false,
  });

  const handleButtonClick = (pdfdata, type) => {
    if (type.toUpperCase() === "URL") {
      const decodedUrl = base64_decode(pdfdata);

      const httpIndex = decodedUrl.indexOf("http");
      const extractedUrl =
        httpIndex !== -1 ? decodedUrl.substring(httpIndex) : decodedUrl;
      window.open(extractedUrl, "_blank");
      // settypeFile(extractedUrl);
    } else {
      setOpenDialog(true);
      setSelectedPDF(pdfdata);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    settypeFile(null);
    setSelectedPDF(null);
  };

  const handleExpandMore = async (type, index, docbody) => {
    setLoadingDeitals(index);
    if (expanded.invoice != index) {
      try {
        const response = await fetchDetials(docbody);
        if (response == 200) {
          setLoadingDeitals(null);
          setExpanded((prevExpanded) => ({
            ...prevExpanded,
            [type]: prevExpanded[type] === index ? false : index,
          }));
        }
      } catch (error) {
        setLoadingDeitals(null);
      }
    } else {
      setLoadingDeitals(null);
      setExpanded((prevExpanded) => ({
        ...prevExpanded,
        [type]: prevExpanded[type] === index ? false : index,
      }));
    }
  };

  const fetchDetials = async (docbody) => {
    let dataBody = docbody;
    try {
      const response = await axios.post(
        "/shipping/sendingDocDetails",
        dataBody
      );
      setInvoiceDetails(response.data.msg);
      return 200;
    } catch (error) {
      if (error.response.status == 400) {
        navigate(`/errormessage`);
      } else if (error.response.status == 403) {
        navigate(`/`);
      } else {
        return 400;
      }
    }
  };

  const handleExpandFiles = (section, index) => {
    setExpandedFiles((prevExpandedFiles) => ({
      ...prevExpandedFiles,
      [section]: prevExpandedFiles[section] === index ? null : index,
    }));
  };

  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#dfedf5",
      fontWeight: "bold",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 15,
    },
  }));

  useEffect(() => {
    setInvoice(null);
    setExpanded(false);
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const formattedDate = `${firstDayOfMonth.getFullYear()}-${String(
      firstDayOfMonth.getMonth() + 1
    ).padStart(2, "0")}-${String(firstDayOfMonth.getDate()).padStart(2, "0")}`;

    setTodate(
      data && data.ivnum
        ? null
        : `${currentDate.getFullYear()}-${String(
            currentDate.getMonth() + 1
          ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(2, "0")}`
    );
    setFromdate(data && data.ivnum ? null : formattedDate);

    async function fetchData() {
      let dataBody = {};
      if (data && data.ivnum) {
        {
          dataBody = {
            withCredentials: true,
            doc: data.ivnum,
          };
        }
      } else {
        dataBody = {
          withCredentials: true,
          doc: "",
          fromdate: data ? data.fromdate : formattedDate,
          todate: data
            ? data.todate
            : `${currentDate.getFullYear()}-${String(
                currentDate.getMonth() + 1
              ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
                2,
                "0"
              )}`,
          skip: 0,
        };
      }
      try {
        const response = await axios.post("/shipping/sendingDoc", dataBody);

        if (
          response.data.status == 200 &&
          response.data.msg.value.length != 0
        ) {
          // console.log(response.data.msg.value, "DATA");
          setInvoice(response.data.msg.value);
          setMessage(false);
        } else if (response.data.msg.value.length == 0) {
          setMessage(true);
          setInvoice([]);
        }
      } catch (error) {
        if (error.response.status == 400) {
          navigate(`/errormessage`);
        } else if (error.response.status == 403) {
          navigate(`/`);
        } else if (error.response.status == 401) {
          setAlert(true);
          setInvoice([]);
          setTimeout(() => {
            setAlert(false);
          }, 10000);
        }
      }
    }
    fetchData();
    // handleValueChange(false);
  }, [clicked]);

  const handleButtonClickOpenNew = (base64String, type) => {
    const pdfWindow = window.open();
    pdfWindow.document.write(
      `<iframe width="100%" height="100%" src="data:application/${type};base64,${base64String}"></iframe>`
    );
  };

  return (
    <>
      {invoice ? (
        <Container maxWidth="xl">
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={alert ? true : false}
            autoHideDuration={6000}
            key={"AlertSnapbar"}
          >
            <Alert
              sx={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}
              severity="warning"
            >
              טווח התאריכים לא יכול להיות יותר משלושה חודשים
            </Alert>
          </Snackbar>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: message ? "none" : "block" },
              marginBottom: "3rem",
            }}
          >
            {/* -------------------------------תעודות מס' מסך גדול-------------------------------------------------------------*/}

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">מספר תעודה</StyledTableCell>
                    <StyledTableCell align="center">תאריך</StyledTableCell>
                    <StyledTableCell align="center">סוג</StyledTableCell>
                    <StyledTableCell align="center"></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoice &&
                    invoice.map((component, index) => (
                      <React.Fragment key={index}>
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              expanded.invoice === index
                                ? "rgb(219, 217, 217)"
                                : null,
                          }}
                        >
                          <TableCell align="center">
                            <Typography align="center" variant="body2">
                              {component.DOCNO == null
                                ? component.IVNUM
                                : component.DOCNO}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography align="center" variant="body2">
                              {moment(component.CURDATE).format("L")}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography align="center" variant="body2">
                              {component.DOCNO == null ? "ח. מס" : "ת. משלוח"}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            {!component.error ? (
                              <LoadingButton
                                variant="text"
                                size="large"
                                onClick={() =>
                                  handleExpandMore(
                                    "invoice",
                                    index,
                                    component.DOCNO == null
                                      ? { doc: component.IVNUM, type: "IVNUM" }
                                      : { doc: component.DOCNO, type: "DOCNO" }
                                  )
                                }
                                endIcon={<ExpandMoreIcon />}
                                loading={loadingDeitals == index}
                                loadingPosition="end"
                              ></LoadingButton>
                            ) : null}
                          </TableCell>
                        </TableRow>

                        {expanded.invoice === index ? (
                          <TableRow
                            sx={{ backgroundColor: "rgb(219, 217, 217)" }}
                          >
                            <TableCell colSpan={4}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "stretch",
                                  // width: "100%",
                                  backgroundColor: "rgb(219, 217, 217)",
                                }}
                              >
                                <Card sx={{ flex: 1, width: "20rem" }}>
                                  <Typography
                                    variant="h6"
                                    sx={{ marginLeft: "0.5rem" }}
                                  >
                                    פירוט תעודה
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      height: "100%",
                                    }}
                                  >
                                    <CardContent>
                                      <Table>
                                        <TableHead>
                                          <TableRow>
                                            <TableCell align="center">
                                              מק"ט
                                            </TableCell>
                                            <TableCell align="center">
                                              תיאור
                                            </TableCell>
                                            <TableCell align="center">
                                              כמות
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {invoicedetails &&
                                            invoicedetails.NEO_DOCANDIVITEMS.map(
                                              (data, index) => (
                                                <TableRow key={index}>
                                                  <StyledTableCell align="center">
                                                    {data.PARTNAME}
                                                  </StyledTableCell>
                                                  <StyledTableCell align="center">
                                                    {data.PDES}
                                                  </StyledTableCell>
                                                  <StyledTableCell align="center">
                                                    {data.TQUANT}
                                                  </StyledTableCell>
                                                </TableRow>
                                              )
                                            )}
                                        </TableBody>
                                      </Table>
                                    </CardContent>
                                  </Box>
                                </Card>

                                <Box
                                  sx={{
                                    width: "1px",
                                    height: "40%",
                                    backgroundColor: "#ccc",
                                    mx: "1rem",
                                  }}
                                ></Box>

                                <Card sx={{ width: "25%" }}>
                                  <Typography
                                    variant="h6"
                                    sx={{ marginLeft: "0.5rem" }}
                                  >
                                    מסמכים
                                  </Typography>
                                  <Box
                                    sx={{
                                      flex: 1,
                                      display: "flex",
                                      justifyContent: "center",
                                      flexWrap: "wrap",
                                      height: "100%",
                                    }}
                                  >
                                    {invoicedetails &&
                                    invoicedetails.NEO_DOCANDIVEXTFILE.length >
                                      0 ? (
                                      invoicedetails.NEO_DOCANDIVEXTFILE.map(
                                        (pdfdata, index) => (
                                          <Box
                                            key={index}
                                            sx={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "left",
                                              padding: "0.5rem",
                                            }}
                                          >
                                            <CardContent>
                                              <IconButton
                                                aria-label="delete"
                                                size="large"
                                                onClick={() =>
                                                  handleButtonClick(
                                                    pdfdata.data,
                                                    pdfdata.type
                                                  )
                                                }
                                              >
                                                <FileDownloadIcon />
                                              </IconButton>
                                              <Typography
                                                variant="caption"
                                                sx={{ marginTop: "0.5rem" }}
                                              >
                                                {pdfdata.filename}.
                                                {pdfdata.type}
                                              </Typography>
                                            </CardContent>
                                          </Box>
                                        )
                                      )
                                    ) : (
                                      <Box>
                                        <Typography variant="caption">
                                          לא נמצא תעודות סרקות במערכת
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                </Card>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ) : null}
                      </React.Fragment>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Dialog open={openDialog} onClose={handleCloseDialog}>
              <DialogTitle align="center">קובץ</DialogTitle>
              {selectedPDF ? (
                <DialogContent>
                  <iframe
                    style={{ width: "500px", height: "700px", border: "none" }}
                    src={`data:application/pdf;base64,${selectedPDF}`}
                  />
                </DialogContent>
              ) : null}
              <DialogActions>
                <Button onClick={handleCloseDialog} color="primary">
                  לסגור
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
          {message ? (
            <Box>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Grid container alignItems="center">
                      <Grid item xs={12}>
                        <Typography align="left" variant="body2">
                          אין תעודות בין תאריכים{" "}
                          {data && data.fromdate
                            ? `${moment(data.fromdate).format("L")}`
                            : fromdate
                            ? ` ${moment(fromdate).format("L")}`
                            : null}{" "}
                          {data && data.todate
                            ? `עד ${moment(data.todate).format("L")}`
                            : fromdate
                            ? `עד ${moment(todate).format("L")}`
                            : null}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Box>
          ) : null}

          {/* ----------------------------------------small box-------------------------------------------------------------------- */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "block", md: "none" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*----------------------------------------------- Invoice small box------------------------------------------ */}

            <List>
              {invoice &&
                invoice.map((component, index) => (
                  <div key={index}>
                    <ListItem>
                      <Container
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "5px",
                          backgroundColor:
                            expanded === index
                              ? "rgb(219, 217, 217)"
                              : "rgb(245, 245, 245)",
                        }}
                      >
                        <ListItemText sx={{ marginRight: "5rem" }}>
                          <Typography
                            variant="caption"
                            sx={{ marginRight: "0.2rem" }}
                          >
                            תעודה:
                          </Typography>
                          <Typography variant="caption">
                            {component.DOCNO == null
                              ? component.IVNUM
                              : component.DOCNO}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ display: "block" }}
                          >
                            {component.CURDATE
                              ? moment(component.CURDATE).format("L")
                              : null}
                          </Typography>
                        </ListItemText>
                        <ListItemButton
                          onClick={() =>
                            handleExpandMore(
                              "invoice",
                              index,
                              component.DOCNO == null
                                ? { doc: component.IVNUM, type: "IVNUM" }
                                : { doc: component.DOCNO, type: "DOCNO" }
                            )
                          }
                        >
                          {!component.error ? (
                            <LoadingButton
                              endIcon={<ExpandMoreIcon />}
                              loading={loadingDeitals == index}
                              loadingPosition="end"
                            ></LoadingButton>
                          ) : null}
                        </ListItemButton>
                        {/* <ListItemButton
                          onClick={() => handleExpandFiles("invoice", index)}
                        >
                          {!component.error ? (
                            <ListItemIcon>
                              <FilePresentIcon />
                            </ListItemIcon>
                          ) : null}
                        </ListItemButton> */}
                      </Container>
                    </ListItem>
                    {expanded.invoice === index ? (
                      <List sx={{ marginLeft: "1rem" }}>
                        {invoicedetails &&
                          invoicedetails.NEO_DOCANDIVITEMS.map(
                            (data, index) => (
                              <List key={index}>
                                <ListItem>
                                  <ListItemText
                                    sx={{
                                      marginLeft: "1rem",
                                      paddingBottom: "-1rem",
                                    }}
                                  >
                                    <Typography variant="caption">
                                      <span
                                        style={{
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {data.PARTNAME}
                                      </span>
                                    </Typography>
                                  </ListItemText>
                                </ListItem>
                                <ListItem>
                                  <ListItemText>
                                    <Typography variant="caption">
                                      תיאור:
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          paddingRight: "5px",
                                        }}
                                      >
                                        {data.PDES}
                                      </span>
                                    </Typography>
                                    <div></div>
                                    <Typography variant="caption">
                                      כמות:
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          paddingRight: "5px",
                                        }}
                                      >
                                        {data.TQUANT}
                                      </span>
                                    </Typography>
                                  </ListItemText>
                                </ListItem>
                                <Divider light variant="middle" />
                              </List>
                            )
                          )}
                      </List>
                    ) : null}
                    {/* <Collapse
                      in={invoice ? expandedFiles.invoice === index : false}
                    >
                      <List>
                        {invoicedetails.NEO_DOCANDIVEXTFILE.map(
                          (pdfdata, index) => (
                            <Box
                              key={index}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                minWidth: "25%",
                                padding: "0.5rem",
                              }}
                            >
                              <IconButton
                                aria-label="delete"
                                size="large"
                                onClick={() =>
                                  handleButtonClickOpenNew(
                                    pdfdata.data,
                                    pdfdata.type
                                  )
                                }
                              >
                                <FileDownloadIcon />
                              </IconButton>
                              <Typography
                                variant="caption"
                                sx={{ marginTop: "0.5rem" }}
                              >
                                {pdfdata.filename}.{pdfdata.type}
                              </Typography>
                            </Box>
                          )
                        )}
                      </List>
                    </Collapse> */}
                  </div>
                ))}
            </List>
          </Box>
        </Container>
      ) : (
        <LoadingBox />
      )}
    </>
  );
}
